import { Box } from "@mui/material";

const SVG_SIZE = 1536;

const overlayBaseSx = {
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    pointerEvents: "none",
    zIndex: 0,
    display: "block",
};

const imgFallbackSx = {
    ...overlayBaseSx,
    objectFit: "fill",
};

/** Copy of pages jigsaw JigsawDieLineOverlay for admin canvas tests. */
export default function TestJigsawDieLineOverlay({ pieces, opacity = 0.6, svgPathFallback, zIndex = 0 }) {
    const list = Array.isArray(pieces) ? pieces : [];
    if (list.length === 0) {
        if (!svgPathFallback) return null;
        return (
            <Box
                component="img"
                src={svgPathFallback}
                alt=""
                referrerPolicy="no-referrer"
                sx={{ ...imgFallbackSx, zIndex, opacity }}
            />
        );
    }

    return (
        <Box
            component="svg"
            viewBox={`0 0 ${SVG_SIZE} ${SVG_SIZE}`}
            preserveAspectRatio="none"
            sx={{ ...overlayBaseSx, zIndex, opacity }}
        >
            {list.map((p, i) => (
                <path
                    key={p.index ?? i}
                    d={p.path}
                    fill="none"
                    stroke="rgba(255,255,255,0.92)"
                    strokeWidth={1.35}
                    strokeLinejoin="round"
                    strokeLinecap="round"
                    vectorEffect="nonScalingStroke"
                />
            ))}
        </Box>
    );
}
